import React from 'react'
import "./TopBar.scss";
import { openNegishut, shareFacebook, shareTwitter } from "../../services/sharing";
const TopBar = () => {
    return (
        <div className="topbar">
            <div className="logos">
                <div className="poalim-logo" onClick={() => window.open("https://www.bankhapoalim.co.il/he", "_blank")}></div>
                <div className="digitalent-logo" onClick={() => window.open("https://digitalent.co.il/", "_blank")}></div>
                <div className="yediot-logo" onClick={() => window.open("https://www.yedioth.co.il/", "_blank")}></div>
                <div className="ynet-logo" onClick={() => window.open("https://www.ynet.co.il/", "_blank")}></div>
            </div>
            <div className="icons">
                <div className="twitter-icon" onClick={() => shareTwitter()}></div>
                <div className="facebook-icon" onClick={() => shareFacebook()}></div>
                <div className="negishut-icon" onClick={() => openNegishut()}></div>
            </div>
        </div>
    )
}

export default TopBar
